function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  color: ",
        ";\n  display: flex;\n  justify-content: center;\n  padding-left: 4px;\n  padding-right: 4px;\n\n  ",
        " {\n    padding-left: 8px;\n    padding-right: 8px;\n  }\n\n  ",
        " {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  list-style-type: none;\n\n  a {\n    color: ",
        ";\n\n    &:hover {\n      color: ",
        ";\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/no-array-index-key */ import React, { Children, isValidElement } from "react";
import styled from "styled-components";
import { space } from "styled-system";
import ChevronRightIcon from "../Svg/Icons/ChevronRight";
var Separator = styled.div.withConfig({
    componentId: "sc-de3e09d6-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.textDisabled;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var StyledBreadcrumbs = styled.ul.withConfig({
    componentId: "sc-de3e09d6-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primaryBright;
}, space);
var insertSeparators = function(items, separator) {
    return items.reduce(function(accum, item, index) {
        if (index === 0) {
            return _toConsumableArray(accum).concat([
                item
            ]);
        }
        return _toConsumableArray(accum).concat([
            /*#__PURE__*/ _jsx(Separator, {
                "aria-hidden": true,
                children: separator
            }, "seperator-".concat(index)),
            item, 
        ]);
    }, []);
};
var DefaultSeparator = /*#__PURE__*/ _jsx(ChevronRightIcon, {
    color: "currentColor",
    width: "24px"
});
var Breadcrumbs = function(param) {
    var _separator = param.separator, separator = _separator === void 0 ? DefaultSeparator : _separator, children = param.children;
    var validItems = Children.toArray(children).filter(function(child) {
        return /*#__PURE__*/ isValidElement(child);
    });
    var items = insertSeparators(validItems, separator);
    return /*#__PURE__*/ _jsx(StyledBreadcrumbs, {
        children: items.map(function(item, index) {
            return /*#__PURE__*/ _jsx("li", {
                children: item
            }, "child-".concat(index));
        })
    });
};
export default Breadcrumbs;
